import React from "react";

const LogsIcon = ({ size = 20, className = "", strokeWidth = 2 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth={strokeWidth}/>
    <path d="M7.5 8.5h9M7.5 12h9M7.5 15.5h9" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round"/>
  </svg>
);

export default LogsIcon;
